import React from "react";
import { Backdrop, Box, CircularProgress, useTheme } from "@mui/material";
import { useAppSelector } from "@application/store/useStore";
const Loader = () => {
    const { isLoading } = useAppSelector((state) => state.loading);
    const theme = useTheme();
    return (React.createElement(Backdrop, { open: false, sx: {
            zIndex: 7000,
            color: theme.palette.primary.contrastText,
            backdropFilter: "blur(4px)",
            backgroundColor: theme.palette.mode === "light"
                ? "rgba(220, 220, 220, 0.6)"
                : "rgba(22, 28, 36, 0.6)",
            transition: "all 0.3s ease-in-out",
        } },
        React.createElement(Box, { sx: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
            } },
            React.createElement(CircularProgress, { size: 60 }))));
};
export default Loader;
